// extracted by mini-css-extract-plugin
export default {"BirthDateInput":"bfr_a bia_z bia_kc bia_qx bia_xc bia_eg","BirthDateInput--disabled":"bfr_b bia_fo"};